import { FormShowTemplate } from 'framework/form';
import { BillingType, BusinessOutcome, Milestone, MILESTONE_STATUS, OUTCOME_STATUS } from 'domain/shared/newProject';
import Milestones from '../../milestones/Milestones';
import { MilestonesType } from '../../milestones/types';
import useMilestonesService, { MILESTONES_ALIAS } from '../../milestones/useMilestonesService';
import { omit, set } from 'lodash';
import { useDashboardProjectDataContext } from 'domain/projects/newProject/context/DashboardProjectContext';
import { EditableListFormShowTemplate, NEW_ROW_ID_PREFIX } from 'framework/list';

const ProjectDashboardMilestonesWrapper = () => {
  const { data, refetch } = useDashboardProjectDataContext();
  const { milestonesBatch, getMilestonesOnDashboardValidationSchema } = useMilestonesService();

  const isMilestoneBillingType = data?.budget?.billingType === BillingType.MILESTONE;
  const businessOutcomes = data?.businessOutcomes?.map(
    ({ alias = '', name = '', status = OUTCOME_STATUS.ACTIVE }: BusinessOutcome) => ({
      alias,
      name,
      status,
    }),
  );

  const isRejectionReason = (milestone: Milestone) => milestone?.status === MILESTONE_STATUS.REJECTED;

  const isChangeReason = data?.milestones?.some((milestone: Milestone) => milestone?.comment);

  const processedData = {
    ...data,
    milestones: data?.milestones?.map((milestone: Milestone) => ({
      ...milestone,
      hasInitialPlannedDateFromBackend: !!milestone.initialPlannedDate,
    })),
  };

  return (
    <FormShowTemplate
      isInitialsLoadingPosition
      submitFormFunc={async values => {
        return milestonesBatch(
          data?.id!,
          values.milestones.map((v: MilestonesType) =>
            omit(
              {
                ...v!,
                ...(v.id.toString().startsWith(NEW_ROW_ID_PREFIX) && {
                  id: null,
                  alias: null,
                  status: OUTCOME_STATUS.ACTIVE,
                }),
                type:
                  data?.budget?.billingType === (BillingType.PERIODIC_PREPAID ?? BillingType.PERIODIC_POSTPAID)
                    ? MILESTONES_ALIAS.NON_BILLING_MILESTONE
                    : v.type,
              },
              ['__typename', 'hasInitialPlannedDateFromBackend'],
            ),
          ),
        ).then(response => set(values, 'milestones', response));
      }}
      afterSubmit={{
        message: 'You are awesome! The Project milestones section has been successfully updated.',
        execute: async () => {
          await refetch();
        },
      }}
      initialData={processedData}
      getValidationSchemaFunc={getMilestonesOnDashboardValidationSchema}
    >
      <EditableListFormShowTemplate listSource="milestones" localStorageKey={`project:${data?.id}:milestones`}>
        <Milestones
          isMilestoneBillingType={isMilestoneBillingType}
          businessOutcomes={businessOutcomes}
          isRejectionReason={isRejectionReason}
          isChangeReason={isChangeReason}
          gridSx={{ pl: 1, pr: '0px !important' }}
          titleVariant="h4"
          accordionSx={{
            '.MuiAccordionSummary-root': { minHeight: '40px !important', pl: '4px', pr: 0, py: 1 },
            '.MuiSvgIcon-root': { fontSize: '20px' },
            '.MuiAccordionDetails-root .MuiGrid2-root': { px: 0 },
            '.MuiAccordionSummary-content': { m: 0 },
          }}
        />
      </EditableListFormShowTemplate>
    </FormShowTemplate>
  );
};
export default ProjectDashboardMilestonesWrapper;
